<template>
  <div>
    <yxt-input-number
      style="width: 200px;"
      v-model="getValue"
      :step="5"
      :precision="0"
      controls-position="right"
      :min="0"
      :max="1440"
    ></yxt-input-number>
    <span class="tlive-duration-minites">
    {{ $t('pc_biz_ote_lbl_minites' /* 分钟 */) }}
    </span>
    <span class="tlive-fast-track">
      <!-- {{ $t('pc_biz_quickOptions' /* 快捷选项 */) }}: -->
      <span
        v-for="time in fastTimeArray"
        :key="time"
        @click="updateDuration(time)"
        >{{ time }}</span
      >
    </span>
  </div>
</template>
<script>
export default {
  name: 'LiveDuration',
  props: {
    value: {
      type: Number,
      default: 60
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {
      fastTimeArray: [30, 45, 60, 90, 120]
    };
  },
  methods: {
    updateDuration(val) {
      this.$emit('input', val);
    }
  }
};
</script>
<style scoped lang="less"></style>
